<div
    [class.mobileWidgetViewWrap]="isDeviceMobile$ | async"
    [class.tabletWidgetViewWrap]="isDeviceTablet$ | async"
    class="widget-specific-nav-align"
    [class]="classes?.chatBotWrapper"
    [id]="getWidgetId"
>
    <ng-container *ngFor="let chatBot of chatBots">
        <a [class]="getStyleList(chatBot)">
            <ng-container *ngIf="chatBot.type === EButtonType.icon">
                <img [src]="getSocialNetworkIconSrcByChatBot(chatBot)" [alt]="chatBot.socialNetwork" />
            </ng-container>
            <ng-container *ngIf="chatBot.type === EButtonType.button">
                <div [innerHTML]="getIcon(chatBot.socialNetwork)" class="icon"></div>
                <span>{{ chatBot.name }}</span>
            </ng-container>
        </a>
    </ng-container>
</div>
